/* Christmas sale: the real countdown, the switch back to regular prices when the end date passes, and the
   festive motion housekeeping. Loaded by layout/theme.liquid only while the sale is on (server date).
   window.npSale = { end: 'YYYY-MM-DD', name } ; the sale ends at the end of that day in the visitor's time.
   [data-np-countdown]  text becomes "Ends in 12d 4h 31m"
   [data-np-sale-only]  hidden once the sale has ended
   [data-np-sale-after] shown once the sale has ended
   [data-np-reg]        text replaced by the regular price once the sale has ended
   [data-now-reg]       picker option: data-now replaced by the regular price, data-was/-save cleared */
(() => {
  const cfg = window.npSale;
  if (!cfg || !cfg.end) return;
  const parts = String(cfg.end).split('-').map(Number);
  if (parts.length !== 3 || parts.some((n) => !n)) return;
  const end = new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59, 999);
  const TICK_MS = 20000;
  const DAY = 86400000;
  const HOUR = 3600000;
  const MIN = 60000;
  const html = document.documentElement;
  let timer = null;

  function ended() {
    html.classList.add('np-sale-over');
    document.body && document.body.classList.remove('np-xmas');
    document.querySelectorAll('[data-np-sale-only]').forEach((el) => { el.hidden = true; });
    document.querySelectorAll('[data-np-sale-after]').forEach((el) => { el.hidden = false; });
    document.querySelectorAll('[data-np-reg]').forEach((el) => {
      el.textContent = el.dataset.npReg;
      el.removeAttribute('data-np-reg');
    });
    document.querySelectorAll('[data-np-picker] input').forEach((r) => {
      if (r.dataset.nowReg) r.dataset.now = r.dataset.nowReg;
      r.dataset.was = '';
      if (r.value === '1') r.dataset.save = '';
    });
    document.querySelector('[data-np-snow]')?.remove();
    document.dispatchEvent(new CustomEvent('np:sale-ended'));
  }

  function label(ms) {
    const d = Math.floor(ms / DAY);
    const h = Math.floor((ms % DAY) / HOUR);
    const m = Math.floor((ms % HOUR) / MIN);
    return d > 0 ? `Ends in ${d}d ${h}h ${m}m` : `Ends in ${h}h ${m}m`;
  }
  function spoken(ms) {
    const d = Math.floor(ms / DAY);
    const h = Math.floor((ms % DAY) / HOUR);
    return d > 0 ? `${cfg.name || 'Sale'} ends in ${d} days and ${h} hours` : `${cfg.name || 'Sale'} ends in ${h} hours`;
  }

  function tick() {
    const ms = end.getTime() - Date.now();
    if (ms <= 0) {
      clearInterval(timer);
      ended();
      return;
    }
    const txt = label(ms);
    const say = spoken(ms);
    document.querySelectorAll('[data-np-countdown]').forEach((el) => {
      if (el.textContent !== txt) el.textContent = txt;
      el.setAttribute('aria-label', say);
    });
  }

  /* Snow: paused while the tab is hidden. Ornaments: paused while their section is off-screen. */
  function housekeeping() {
    const snow = document.querySelector('[data-np-snow]');
    if (snow) {
      const sync = () => snow.classList.toggle('is-paused', document.hidden);
      document.addEventListener('visibilitychange', sync);
      sync();
    }
    if (!('IntersectionObserver' in window)) return;
    const obs = new IntersectionObserver((entries) => entries.forEach((e) => e.target.classList.toggle('np-off', !e.isIntersecting)));
    document.querySelectorAll('.np-sec').forEach((s) => {
      s.classList.add('np-off');
      obs.observe(s);
    });
  }

  const start = () => {
    tick();
    if (Date.now() < end.getTime()) {
      timer = setInterval(tick, TICK_MS);
      housekeeping();
    }
    document.addEventListener('visibilitychange', () => { if (!document.hidden) tick(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
